import React from 'react';
import type { ClickAwayListenerProps } from '@mui/material/ClickAwayListener';
import MuiClickAwayListener from '@mui/material/ClickAwayListener';
import { styled } from 'styled-components';

const Molecule: React.FC<ClickAwayListenerProps> = (props) => <MuiClickAwayListener { ...props } />;

export const ClickAwayListener = styled(Molecule)({});
